export class Location {
    constructor(
        public id?: number,
        public name?: string,
        public maxParticipants?: number,
        public schoolId?: number,
        public active?: boolean
    ) {
        this.active = active ? active : false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/location/location.model.ts